<template>
  <div class="gift-container">
    <div class="gift-content gift-content-top">
      <img src="../../assets/images/xnlb/xnlb_01.jpg" />
    </div>
    <div class="gift-content gift-content-title">
      <div class="text-notice">*该礼包为预售产品，预计23号开始发货</div>
      <div class="text-title">老传统 新演绎</div>
      <div class="text-ins">够礼面/够独特/够心意</div>
    </div>
    <div class="gift-content gift-content-bg">
      <img src="../../assets/images/xnlb/xnlb_03.jpg" />
    </div>
    <div class="gift-content gift-content-text">
      <div class="content-text">
        <p class="content-text-title">新年大礼包内含：</p>
        <p>新年贺卡*1张</p>
        <p>灯笼茶具*1套</p>
        <p>Knoppers德国进口威化饼干25g*6包</p>
        <p>好丽友薯愿薯片104g*1盒</p>
        <p>大白兔奶糖227g*1袋</p>
        <p>美国蓝钻扁桃仁70g*2袋</p>
        <p>瑞士莲可可脂巧克力100g*1袋</p>
      </div>
      <div class="content-btn">
        <span>*限量600份</span>
        <div class="btn" @click="showItem">
          <img src="../../assets/images/xnlb/xnlb_icon.jpg">
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { commonUtils } from '@/utils/common'
import { userUtils } from '@/utils/auth'
export default {
  name: 'NewYearGift',
  data () {
    return {
      itemId: '4374'
    }
  },
  created () {
    this.clientInfo = userUtils.getClientInfo()
    if (!this.clientInfo) {
      window.location.href = commonUtils.getExtraSite() + '/#/login'
    }
  },
  methods: {
    showItem () {
      window.location.href = commonUtils.getExtraSite() + '/#/goodsDetail/' + this.itemId
    }
  }
}
</script>

<style lang="less" scoped>
.gift-container {
  font-size: 0;
  min-height: 100%;
  background-color: #d73f32;
  img {
    width: 100%;
    margin-top: -1px;
    z-index: 0;
  }
  .gift-content {
    position: relative;
    box-sizing: border-box;
  }
  .gift-content-title {
    height: 115px;
    background: url("../../assets/images/xnlb/xnlb_02.jpg") no-repeat;
    background-size: 100% 100%;
    text-align: center;
    .text-notice {
      color: #fbe1c8;
      font-size: 14px;
      font-weight: bold;
      padding-top: 3px;
    }
    .text-title {
      color: #000;
      font-size: 16px;
      font-weight: bold;
      bottom: 20px;
      padding-top: 60px;
    }
    .text-ins {
      color: #d73f32;
      font-size: 12px;
      padding-top: 4px;
    }
  }
  .gift-content-text {
    min-height: 155px;
    margin-top: -1px;
    background: url("../../assets/images/xnlb/xnlb_04.jpg") no-repeat;
    background-size: 100% 100%;
    padding: 0 28px;
    display: flex;
    justify-content: space-between;
    color: #000;
    font-size: 12px;
    p {
      line-height: 15px;
    }
    .content-text-title {
      color: #d73f32;
      font-size: 13px;
      font-weight: bold;
      padding-bottom: 2px;
    }
    .content-btn {
      text-align: right;
      padding-top: 76px;
      .btn {
        width: 117px;
        height: 28px;
        margin-top: 4px;
      }
    }
  }
}
</style>
